// import {
//     NPAPOPUP,
//     NPAPOPUP_SUCCESS,
//     NPAPOPUP_FAIL,
// } from "./actiontype"


// export const NpaPopup =({employeeID,HRControl})=>{
//     return {
//         type:NPAPOPUP,
//         payload: {employeeID,HRControl},
//     }
// };

// export const NpaPopupSuccess =(response)=>{
//     return{
//         type: NPAPOPUP_SUCCESS,
//         payload:response
//     }
// }

// export const NpaPopupFail =(error)=>{
//     return{
//         type:NPAPOPUP_FAIL,
//         payload:error,
//     }
// }
import {NPAPOPUP,NPAPOPUP_FAIL,NPAPOPUP_SUCCESS,} from "./actiontype"

export const NpaDetails =(employeeID,HrControl,NatureActionCode)=>{
       return{
        type:NPAPOPUP,
        payload:{employeeID,HrControl,NatureActionCode}
       }
    }
export const NpaDetailsSuccess=(response)=>{
    return {
        type:NPAPOPUP_SUCCESS,
        payload:response
    }
} 
export const NpaDetailsFail =(error)=>{
    return{
    type:NPAPOPUP_FAIL,
    payload:error
    }
}